<template>
<div class="chapter">
<div class="inner_page">
<p class="chapname" id="id2"><span class="bold">Contents</span></p>
<p class="toc"><a href="#/00c_AMERICAN_EXPEDITIONARY_FORCE"><span class="bold">Introduction</span></a></p>
<p class="toc"><a href="#/01a_AMERICAN_EXPEDITIONARY_FORCE">Chapter One</a></p>
<p class="toc1"><a href="#/01a_AMERICAN_EXPEDITIONARY_FORCE"><span class="bold">‘We Go To War’ – April 1917</span></a></p>
<p class="toc"><span href="#/02a_AMERICAN_EXPEDITIONARY_FORCE" title="Link target outside of Sample">Chapter Two</span></p>
<p class="toc1"><span href="#/02a_AMERICAN_EXPEDITIONARY_FORCE" title="Link target outside of Sample"><span class="bold">The Yanks Are Coming</span></span></p>
<p class="toc"><span href="#/03a_AMERICAN_EXPEDITIONARY_FORCE" title="Link target outside of Sample">Chapter Three</span></p>
<p class="toc1"><span href="#/03a_AMERICAN_EXPEDITIONARY_FORCE" title="Link target outside of Sample"><span class="bold">Training and Trench Fighting</span></span></p>
<p class="toc"><span href="#/04a_AMERICAN_EXPENDITIONARY_FORCE" title="Link target outside of Sample">Chapter Four</span></p>
<p class="toc1"><span href="#/04a_AMERICAN_EXPENDITIONARY_FORCE" title="Link target outside of Sample"><span class="bold">First Offensive Action – Cantigny</span></span></p>
<p class="toc"><span href="#/05a_AMERICAN_EXPEDITIONARY_FORCE" title="Link target outside of Sample">Chapter Five</span></p>
<p class="toc1"><span href="#/05a_AMERICAN_EXPEDITIONARY_FORCE" title="Link target outside of Sample"><span class="bold">Chateau Thierry</span></span></p>
<p class="toc"><span href="#/06a_AMERICAN_EXPEDITIONARY_FORCE" title="Link target outside of Sample">Chapter Six</span></p>
<p class="toc1"><span href="#/06a_AMERICAN_EXPEDITIONARY_FORCE" title="Link target outside of Sample"><span class="bold">St Mihiel</span></span></p>
<p class="toc"><span href="#/07a_AMERICAN_EXPEDITIONARY_FORCE" title="Link target outside of Sample">Chapter Seven</span></p>
<p class="toc1"><span href="#/07a_AMERICAN_EXPEDITIONARY_FORCE" title="Link target outside of Sample"><span class="bold">Meause-Argonne</span></span></p>
<p class="toc"><span href="#/08a_AMERICAN_EXPEDITIONARY_FORCE" title="Link target outside of Sample">Chapter Eight</span></p>
<p class="toc1"><span href="#/08a_AMERICAN_EXPEDITIONARY_FORCE" title="Link target outside of Sample"><span class="bold">Victory and Armistice</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 00b_AMERICAN_EXPEDITIONARY_FORCE.vue?64798ac0